"use client";
import React, { useRef } from "react";
import Image from "next/image";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Beer from "../../../../public/assets/client/beer/abinbev.webp";
import Beer2 from "../../../../public/assets/client/beer/godfather.webp";
import Beer3 from "../../../../public/assets/client/beer/cg.png";
import Beer4 from "../../../../public/assets/client/beer/grag-trader.png";
import Beer5 from "../../../../public/assets/client/beer/ub.png";

gsap.registerPlugin(ScrollTrigger);

const clientImages = [Beer, Beer2, Beer3, Beer4, Beer5];

const BeerClients = () => {
  const sectionRef = useRef(null);

  return (
    <section
      className="bg-white py-[50px]  px-4 md:px-0 !mb-3 xl:block hidden"
      ref={sectionRef}
    >
      <div className="container mx-auto">
        <h2 className="text-4xl font-extrabold text-center mb-12 text-[#033b6f]">
          Our <span className="text-[#d42427]"> Clients</span>
        </h2>

        <div className="grid grid-cols-5 gap-3">
          {clientImages.map((img, i) => (
            <div key={i} className="px-3">
              <div className="border border-gray-200 shadow-2xl rounded-lg p-2 bg-white transition-all duration-300 hover:scale-105">
                <Image
                  src={img}
                  alt={`client-${i}`}
                  className=" rounded-lg object-contain"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeerClients;
